<template>
  <div>
    <div v-if="showDock" class="tpv-controls-dock" :class="{ 'tpv-controls-dock--open': dockExpanded }">
      <button class="tpv-controls-dock__toggle" type="button" @click="dockExpanded = !dockExpanded">
        <i class="fa-solid" :class="dockExpanded ? 'fa-xmark' : 'fa-grip'"></i>
      </button>
      <transition name="dock-slide">
        <div v-if="dockExpanded" class="tpv-controls-dock__items">
          <router-link
            v-for="item in dockItems"
            :key="item.route"
            :to="item.route"
            class="tpv-controls-dock-item"
            :class="{ 'tpv-controls-dock-item--active': $route.path === item.route }"
            @click="dockExpanded = false"
          >
            <i :class="item.icon" class="tpv-controls-dock-item__icon"></i>
            <span class="tpv-controls-dock-item__label">{{ item.label }}</span>
          </router-link>
        </div>
      </transition>
    </div>

    <div v-if="showDock && dockExpanded" class="tpv-controls-dock-backdrop" @click="dockExpanded = false"></div>

    <div
      v-if="shouldShowTranslate"
      class="dropdown tpv-controls-translate position-fixed"
      :class="[translatePlacementClass, { dropup: shouldUseTranslateDropup, 'tpv-controls-translate--lifted-footer': liftForFooter, 'tpv-controls-translate--customer': liftForFooter }]"
    >
      <button class="btn tpv-controls-translate__btn rounded-4" type="button" data-bs-toggle="dropdown" aria-expanded="false" :aria-label="liftForFooter ? 'Traducir la carta' : 'Cambiar idioma'">
        <i class="bi bi-translate"></i>
      </button>
      <ul class="dropdown-menu" :class="liftForFooter ? 'dropdown-menu-start' : 'dropdown-menu-end'">
        <li><button type="button" class="dropdown-item" @click="$emit('translate', 'es')"><img src="@/assets/spain_flag.svg" class="tpv-controls-flag-image me-2" alt="" /> Español</button></li>
        <li><button type="button" class="dropdown-item" @click="$emit('translate', 'ca')"><img src="@/assets/catalunya_flag.svg" class="tpv-controls-flag-image me-2" alt="" /> Catalán</button></li>
        <li><button type="button" class="dropdown-item" @click="$emit('translate', 'gl')"><img src="@/assets/galicia_flag.svg" class="tpv-controls-flag-image me-2" alt="" /> Gallego</button></li>
        <li><button type="button" class="dropdown-item" @click="$emit('translate', 'eu')"><img src="@/assets/vasca_flag.svg" class="tpv-controls-flag-image me-2" alt="" /> Euskera</button></li>
        <li><button type="button" class="dropdown-item" @click="$emit('translate', 'en')"><img src="@/assets/uk_flag.svg" class="tpv-controls-flag-image me-2" alt="" /> Inglés</button></li>
        <li><button type="button" class="dropdown-item" @click="$emit('translate', 'ar')"><img src="@/assets/morocco_flag.svg" class="tpv-controls-flag-image me-2" alt="" /> Árabe</button></li>
        <li><button type="button" class="dropdown-item" @click="$emit('translate', 'fr')"><img src="@/assets/france_flag.svg" class="tpv-controls-flag-image me-2" alt="" /> Francés</button></li>
        <li><button type="button" class="dropdown-item" @click="$emit('translate', 'pt')"><img src="@/assets/portugal_flag.svg" class="tpv-controls-flag-image me-2" alt="" /> Portugués</button></li>
        <li><button type="button" class="dropdown-item" @click="$emit('translate', 'ru')"><img src="@/assets/russia_flag.svg" class="tpv-controls-flag-image me-2" alt="" /> Ruso</button></li>
        <li><button type="button" class="dropdown-item" @click="$emit('translate', 'uk')"><img src="@/assets/ukraine_flag.svg" class="tpv-controls-flag-image me-2" alt="" /> Ucraniano</button></li>
      </ul>
      <div v-if="translateError" class="tpv-controls-translate__error" role="alert">{{ translateError }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TpvFloatingControls',
  props: {
    showDock: { type: Boolean, default: false },
    showTranslate: { type: Boolean, default: false },
    dockItems: { type: Array, default: () => [] },
    liftForFooter: { type: Boolean, default: false },
    translateError: { type: String, default: '' }
  },
  emits: ['translate'],
  data() {
    return {
      dockExpanded: false
    }
  },
  computed: {
    shouldShowTranslate() {
      if (!this.showTranslate) return false
      if (this.showDock) return this.dockExpanded
      return true
    },
    translatePlacementClass() {
      if (this.showDock && this.dockExpanded) return 'tpv-controls-translate--above-dock'
      if (this.$route.name === 'TPVHub') return 'tpv-controls-translate--dock-slot'
      return 'tpv-controls-translate--default'
    },
    shouldUseTranslateDropup() {
      return this.liftForFooter || (this.showDock && this.dockExpanded)
    }
  },
  watch: {
    '$route.path'() {
      this.dockExpanded = false
    }
  }
}
</script>

<style scoped>
.tpv-controls-dock {
  position: fixed;
  bottom: calc(var(--tpv-dock-bottom, 24px) + var(--tpv-dock-collision-lift-mobile, 0px) + env(safe-area-inset-bottom, 0px));
  left: 24px;
  z-index: 1055;
  display: flex;
  align-items: flex-end;
  gap: 0;
}

.tpv-controls-dock__toggle {
  width: 56px;
  height: 56px;
  border: none;
  border-radius: 17px;
  background: #F47700;
  color: #fff;
  font-size: 1.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(244,119,0,0.35);
  transition: all 0.25s ease;
  flex-shrink: 0;
  z-index: 2;
}

.tpv-controls-dock__toggle:hover {
  transform: scale(1.06);
  box-shadow: 0 6px 22px rgba(244,119,0,0.45);
}

.tpv-controls-dock--open .tpv-controls-dock__toggle {
  border-radius: 17px 0 0 17px;
}

.tpv-controls-dock__items {
  display: flex;
  align-items: stretch;
  height: 56px;
  background: #fff;
  border-radius: 0 17px 17px 0;
  box-shadow: 0 4px 24px rgba(0,0,0,0.12);
  overflow-x: auto;
  overflow-y: hidden;
  max-width: calc(100vw - 108px);
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.tpv-controls-dock__items::-webkit-scrollbar {
  display: none;
}

.tpv-controls-dock-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 78px;
  min-height: 56px;
  padding: 11px 15px;
  box-sizing: border-box;
  text-decoration: none;
  color: #666;
  font-size: 0.73rem;
  transition: all 0.2s ease;
  flex-shrink: 0;
  gap: 5px;
  border-right: 1px solid #f0f0f0;
}

.tpv-controls-dock-item:last-child {
  border-right: none;
}

.tpv-controls-dock-item:hover {
  color: #F47700;
  background: #FFF7EE;
}

.tpv-controls-dock-item--active {
  color: #F47700;
  background: #FFF3E6;
  font-weight: 600;
}

.tpv-controls-dock-item__icon {
  font-size: 1.22rem;
}

.tpv-controls-dock-item__label {
  white-space: nowrap;
  line-height: 1.1;
}

.tpv-controls-dock-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.15);
  z-index: 1054;
}

.dock-slide-enter-active {
  transition: all 0.3s ease;
}

.dock-slide-leave-active {
  transition: all 0.2s ease;
}

.dock-slide-enter-from,
.dock-slide-leave-to {
  opacity: 0;
  transform: translateX(-20px) scaleX(0.7);
  transform-origin: left center;
}

.tpv-controls-translate {
  width: 56px !important;
  z-index: 1060;
}

.tpv-controls-translate--default {
  right: 24px;
  bottom: calc(24px + env(safe-area-inset-bottom, 0px)) !important;
}

.tpv-controls-translate--lifted-footer.tpv-controls-translate--default {
  bottom: calc(82px + env(safe-area-inset-bottom, 0px)) !important;
}

.tpv-controls-translate--customer.tpv-controls-translate--default {
  left: 24px;
  right: auto;
  bottom: calc(var(--customer-nav-total, calc(80px + env(safe-area-inset-bottom, 0px))) + 24px) !important;
  width: 48px !important;
}

.tpv-controls-translate--customer .tpv-controls-translate__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  padding: 0;
  border: 1px solid rgba(var(--primary-color-rgb, 244, 119, 0), 0.28);
  border-radius: 999px !important;
  background: #fff;
  box-shadow: 0 7px 20px rgba(18, 34, 49, 0.14);
  font-size: 1.15rem;
}

.tpv-controls-translate--dock-slot {
  left: 24px;
  bottom: calc(24px + env(safe-area-inset-bottom, 0px)) !important;
}

.tpv-controls-translate--above-dock {
  left: 24px;
  bottom: calc(var(--tpv-dock-bottom, 24px) + 66px + env(safe-area-inset-bottom, 0px)) !important;
}

.tpv-controls-translate__btn {
  width: 56px;
  height: 56px;
  background: transparent;
  border: 2px solid var(--primary-color);
  color: var(--primary-color);
  font-size: 1.4rem;
  box-shadow: 0 6px 14px rgba(0,0,0,0.12);
  transition: transform 0.25s, box-shadow 0.25s, background-color 0.2s, color 0.2s, border-color 0.2s;
}

.tpv-controls-translate__btn:hover {
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 8px 18px rgba(0,0,0,0.2);
}

.tpv-controls-translate__btn:active {
  transform: translateY(4px) scale(0.98);
  box-shadow: 0 3px 8px rgba(0,0,0,0.1);
}

.tpv-controls-translate__btn:focus-visible {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 0.2rem rgba(244,119,0,0.22);
  color: var(--primary-color);
}

.tpv-controls-translate.show .tpv-controls-translate__btn,
.tpv-controls-translate__btn[aria-expanded="true"] {
  background: var(--primary-color);
  border-color: var(--primary-color);
  color: #fff;
}

.tpv-controls-translate .dropdown-menu {
  margin-top: 4px !important;
}

.tpv-controls-translate.dropup .dropdown-menu {
  margin-top: 0 !important;
  margin-bottom: 4px !important;
}

.tpv-controls-translate__error {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 0;
  width: min(260px, calc(100vw - 28px));
  padding: 10px 12px;
  border: 1px solid #f4c8c8;
  border-radius: 12px;
  background: #fff7f7;
  box-shadow: 0 7px 22px rgba(20, 33, 47, 0.14);
  color: #a32323;
  font-size: 0.8rem;
  line-height: 1.35;
}

.tpv-controls-flag-image {
  width: 1.7rem;
  height: 1.1rem;
  object-fit: cover;
  border-radius: 999px;
  box-shadow: 0 0 0 1px rgba(15,23,42,0.08);
}

.dropdown-item {
  transition: padding-left 0.2s, background-color 0.2s;
  cursor: pointer;
}

.dropdown-item:hover {
  padding-left: 1.5rem;
  background-color: #f8f9fa;
}

@media (max-width: 768px) {
  .tpv-controls-dock {
    left: 14px;
    bottom: calc(var(--tpv-dock-bottom-mobile, 14px) + var(--tpv-dock-collision-lift-mobile, 0px) + env(safe-area-inset-bottom, 0px));
  }

  .tpv-controls-translate--default {
    right: 14px;
    bottom: calc(14px + env(safe-area-inset-bottom, 0px)) !important;
  }

  .tpv-controls-translate--lifted-footer.tpv-controls-translate--default {
    bottom: calc(82px + env(safe-area-inset-bottom, 0px)) !important;
  }

  .tpv-controls-translate--customer.tpv-controls-translate--default {
    left: 14px;
    right: auto;
    bottom: calc(var(--customer-nav-total, calc(80px + env(safe-area-inset-bottom, 0px))) + 24px) !important;
  }

  .tpv-controls-translate--customer .tpv-controls-translate__btn {
    width: 48px;
    height: 48px;
  }

  .tpv-controls-translate--dock-slot {
    left: 14px;
    bottom: calc(14px + env(safe-area-inset-bottom, 0px)) !important;
  }

  .tpv-controls-translate--above-dock {
    left: 14px;
    bottom: calc(var(--tpv-dock-bottom-mobile, 14px) + 64px + env(safe-area-inset-bottom, 0px)) !important;
  }

  .tpv-controls-dock__toggle,
  .tpv-controls-translate__btn {
    width: 52px;
    height: 52px;
  }

  .tpv-controls-dock__items {
    height: 52px;
    max-width: calc(100vw - 92px);
  }

  .tpv-controls-dock-item {
    min-width: 74px;
    min-height: 52px;
    padding: 10px 14px;
  }
}
</style>
